import Container from '~/components/common/container';

interface SectionProps {
   title?: string;
   content: string;
   image: string;
   innerImage?: string;
   leading?: boolean;
   //    button?: string;
}
const Section = ({ title, content, image, innerImage, leading }: SectionProps) => {
   return (
      <div>
         <Container>
            <div className="lg:grid lg:grid-cols-2 gap-4 flex flex-col">
               <div className="pt-32">
                  <div className="text-4xl font-bold">{title}</div>
                  <div className="py-5 lg:ltr:pr-10 lg:rtl:pl-10 text-xl">{content}</div>
                  <img src={innerImage} />
               </div>
               <div className="pt-10">
                  <img src={image} />
               </div>
            </div>
         </Container>
         <div className={leading ? 'border-b border-gray-50' : ''}></div>
      </div>
   );
};
export default Section;
